import keyMirror from 'keymirror'

export const types = keyMirror({
  // common
  UPDATE_PATH_FIELD: null,
  RESET_STATE: null,
  LOGOUT_RESET_STATE: null,
  UPDATE_CURRENCIES: null,

  // -------------------------------------------
  // --- Form mutations
  FORM_UPDATE: null,

  // -------------------------------------------
  // --- Setting mutations
  SETTING_LOAD_VALUE: null,
  SETTING_LOAD_ALL_VALUE: null,
  BACK_END_ENV_UPDATE: null,
  JSON_WEB_TOKEN: null,

  // --- User mutations
  USER_UPDATE_CURRENT: null,
  ACCESS_UPDATE: null,
  USER_CONTACT_CURRENT: null,
  CURRENT_GLOBAL_USER: null,
  USER_VISIT_TR: null,

  // --- Region mutations
  CURRENT_REGION: null,
  REGIONS: null,
  ACTIVE_REGIONS: null,
  PUBLIC_PATH_LAST_SELECTED_REGION: null,
  BACKEND_REGIONAL_ENV_UPDATE: null,
  CROSS_REGION_LOGIN: null,

  // -------------------------------------------
  // --- Tender mutations
  TENDER_LOAD_ALL: null,
  TENDER_LOAD_CURRENT: null,
  TENDER_UPDATE_CURRENT: null,
  TENDER_PREPARE_DATA_FOR_EDIT: null,
  TENDER_UPDATE_EDIT_STATUS_FIELDS: null,
  TENDER_UPDATE_FIELD: null,
  TENDER_UPDATE_PATH_FIELD: null,
  TENDER_UPDATE_DEPARTMENT: null,
  TENDER_LOAD_ADDENDUMS: null,
  TENDER_LOAD_RECENT_REVISION: null,
  ADDENDUM_UPDATE_CLASS_NAME: null,
  SET_LAST_SEARCH_ATTRIBUTES: null,
  TENDER_LOAD_ALL_LAST_SEARCHED: null,
  TENDER_CLEAR_SECTION_FOR_REFERENCE: null,

  TENDER_REFRESH_BID: null,
  TENDER_CURRENT_BID_ID: null,
  TENDER_SET_CURRENT_BID: null,
  TENDER_UPDATE_QUERY_BY_PATH: null,
  TENDER_SET_TERM_VERSION: null,
  UPDATE_TNC: null,
  RESET_TNC: null,
  SET_TNC: null,

  // -------------------------------------------
  // --- Project mutations
  PROJECT_UPDATE_CURRENT: null,
  PROJECT_LOAD_ALL_LAST_SEARCHED: null,

  // -------------------------------------------
  // --- Company mutations
  COMPANY_LOAD_CURRENT: null,
  COMPANY_UPDATE_CURRENT: null,
  COMPANY_UPDATE_PATH_FIELD: null,
  COMPANY_CREATE: null,
  COMPANY_REMOVE_CONTACT: null,
  COMPANY_CONTACT_UPDATE_PATH_FIELD: null,

  // -------------------------------------------
  // --- Contact mutations
  CONTACT_LOAD_CURRENT: null,
  CONTACT_UPDATE_CURRENT: null,
  CONTACT_RESET_CURRENT: null,
  CONTACT_CREATE: null,
  CONTACT_UPDATE_PATH_FIELD: null,
  CONTACT_UPDATE_PATH_ARRAY_FIELD: null,
  CONTACT_PUSH_ITEM_TO_ARRAY: null,
  CONTACT_REMOVE_COMPANY: null,
  TENANCY_CONTACT_UPDATE_EMERGENCY_POSITION: null,

  // -------------------------------------------
  // --- Directory
  DIRECTORY_SET_CURRENT: null,
  DIRECTORY_SET_FIELD_BY_PATH: null,
  DIRECTORY_SET_ORDER: null,
  DIRECTORY_TENANCY_INFO: null,
  DIRECTORY_UPDATE_COMPANY: null,
  DIRECTORY_RESET_CURRENT: null,
  DIRECTORY_RESET: null,

  // -------------------------------------------
  // -- Tenancy mutations
  TENANCY_LOAD_CURRENT: null,
  TENANCY_CREATE: null,
  TENANCY_UPDATE_CURRENT: null,
  TENANCY_UPDATE_PATH_FIELD: null,
  TENANCY_RESET_CURRENT: null,
  TENANCY_CONTACT_UPDATE_PATH_FIELD: null,
  TENANCY_ADD_LEASE: null,
  TENANCY_REMOVE_LEASE: null,
  TENANCY_UPDATE_COMPANY_LEASE: null,
  TENANCY_REMOVE_ALL_LEASES: null,
  TENANCY_LOAD_ALL: null,
  SET_LAST_SEARCHED_KEYS: null,
  TENANCY_UPDATE_ACCOUNTS: null,
  TR_ECIRCULAR_SEARCH_RESULTS: null,
  TR_ECIRCULAR_SAVE_SEARCH_COUNT: null,
  TR_ECIRCULAR_SAVE_ECIRCULAR_FILTER_CONDITIONS: null,
  TR_ECIRCULAR_SAVE_ECIRCULAR_TABLE_ORDER: null,
  REDIRECT_LINK_UPDATE: null,
  TENANCY_UPDATE_OPENING_HOURS: null,

  // ------------------------------------------
  // --- CCD Advance search mutations
  ADVANCE_SEARCH_SET_SEARCH_CONDITIONS: null,
  ADVANCE_SEARCH_SET_SEARCH_RESULTS: null,
  ADVANCE_SEARCH_SET_SEARCH_TOTAL: null,
  ADVANCE_SEARCH_RESET_ALL: null,

  // ------------------------------------------
  PERFORMANCE_SEARCH_CONDITIONS: null,
  PERFORMANCE_SEARCH_RESULTS: null,

  // ------------------------------------------
  // --- TMS Handover & Takeback
  HOTB_SET_CURRENT: null,

  HOTB_UPDATE_FIELD_PATH: null,
  HOTB_UPDATE_CONTACT_INFO: null,
  HOTB_UPDATE_HKLD_HANDOVER_CONTACTS: null,
  HOTB_SCHEDULE_DELETE: null,
  HOTB_SET_FILTER_DATE_INDEX: null,
  HOTB_SET_MY_TENANT_PROJECTS_FILTER_DATE_INDEX: null,
  HOTB_LOAD_ALL: null,
  HOTB_LOAD_VIEW_ALL: null,
  HOTB_SET_CURRENT_TYPE: null,

  // --- All Tenant Projects list → detail Prev/Next (HOTB + Tenant Project rows)
  LIST_NAVIGATION_SET_SEQUENCE: null,
  LIST_NAVIGATION_SET_TENANCY_BACK_PATH: null,
  /** Copy `sequence` → suspended when leaving TenancyView with All Tenancy Records prev/next intact */
  LIST_NAVIGATION_SUSPEND_TENANCY_RECORD_SEQUENCE: null,
  LIST_NAVIGATION_CLEAR_SUSPENDED_TENANCY_RECORD: null,

  // ------------------------------------------
  // --- TMS Tenant Project
  TENANT_PROJECT_CURRENT: null,
  TENANT_PROJECT_UPDATE_FIELD_PATH: null,
  TENANT_PROJECT_UPDATE_FIELD_NAME: null,
  TENANT_PROJECT_RESET: null,
  TENANT_PROJECT_ACCOUNTS: null,
  TENANT_PROJECT_LOAD_ALL: null,
  SET_LAST_SEARCH_ATTRIBUTES_ALL: null,
  TENANT_PROJECT_LOAD_VIEW_ALL: null,
  TENANT_PROJECT_SET_START_REVIEW: null,
  TENANT_PROJECT_RESET_PROJECT_SUBMISSION: null,
  TENANT_PROJECT_DEPOSIT: null,
  TENANT_PROJECT_REFUND: null,
  TENANT_PROJECT_MANAGEMENT: null,
  TENANT_PROJECT_FINALDOCUMENT: null,
  TENANT_PROJECT_INSEPCTIONS: null,
  SET_CURR_TENANT_PROJECT_FINALDOCUMENT: null,
  TENANT_PROJECT_CLEAN_EMPTY_ACCOUNTS: null,
  SET_TENANT_PROJECT_SUBMISSION_BY_ID: null,
  TP_UPDATE_TECH_COMMENTS_BY_ID: null,

  // -------------------------------------------
  // --- The Post fitout letter submissions
  TP_POST_FITOUT_SUBMISSIONS: null,
  TP_POST_FITOUT_UR_SUBMISSION: null,
  TP_POST_FITOUT_UPDATE_FIELD_PATH: null,
  TP_POST_FITOUT_UPDATE_PENDING_GUIDELINE: null,
  TP_POST_FITOUT_RESET: null,

  // -------------------------------------------
  // --- E-Circular
  ECIRCULAR_CURRENT: null,
  ECIRCULAR_UPDATE_FIELD_PATH: null,
  ECIRCULAR_UPDATE_HISTORY_FIELD_PATH: null,
  ECIRCULAR_UPDATE_FIELD_NAME: null,
  ECIRCULAR_RESET_CURRENT: null,
  ECIRCULAR_LIST_LOAD: null,
  ECIRCULAR_LOAD_ONE: null,
  ECIRCULAR_UPDATE_ONE_ATTRIBUTE: null,
  ECIRCULAR_NAV_TO_RECIPIENT_OWNER: null,
  ECIRCULAR_SAVE_SEARCH_RECIPIENT_CONDITIONS: null,
  ECIRCULAR_SAVE_SEARCH_VENDOR_RECIPIENT_CONDITIONS: null,
  ECIRCULAR_SAVE_SEARCH_RECIPIENTS: null,
  ECIRULAR_ADDED_RECIPIENTS: null,
  ECIRCULAR_SEARCH_RESULTS: null,
  ECIRCULAR_SAVE_SEARCH_COUNT: null,
  ECIRCULAR_SAVE_ECIRCULAR_FILTER_CONDITIONS: null,
  ECIRCULAR_SAVE_ECIRCULAR_TABLE_ORDER: null,
  ECIRCULAR_GET_CATEGORIES: null,

  // -------------------------------------------
  // --- work permit
  WORKPERMIT_SET_PROJECT_WORKPERMIT: null,
  WORKPERMIT_SET_TENANCY_WORKPERMIT: null,
  WORKPERMIT_SET_CURRENT_WORKPERMIT: null,
  WORKPERMIT_SET_SEARCH_ATTRS: null,
  WORKPERMIT_SET_SEARCH_RESULT: null,
  WORKPERMIT_SET_WORKPERMIT_FIELD_BY_NAME: null,
  WORKPERMIT_SET_WORKPERMIT_LIST_OF_CURRENT_PROJECT: null,
  WORKPERMIT_ADD_NEW_HOISTING: null,
  WORKPERMIT_SET_HOISTING: null,
  WORKPERMIT_SET_HOISTING_ATTRIBUTE: null,
  WORKPERMIT_SET_WORKER_INFO: null,
  WORKPERMIT_SET_VALUE_FOR_WORKER_INFO: null,
  WORKPERMIT_DELETE_HOT_WORK: null,
  WORKPERMIT_ADD_HOT_WORK: null,
  WORKPERMIT_SET_HOT_WORK_INFO: null,
  WORKPERMIT_DELETE_HOISTING_LOCAL: null,
  WORKPERMIT_REPLACE_HOISTING: null,
  WORKPERMIT_SET_PARENT_PERMIT: null,
  WORKPERMIT_SET_BUILDING_FLOOR_MAP: null,
  WORKPERMIT_SET_REVIEW_MAP: null,
  WORKPERMIT_SET_REVIEW_QUEUE: null,
  WORKPERMIT_ADD_TO_REVIEW_QUEUE_HEAD: null,
  WORKPERMIT_DEQUEUE_REVIEW_QUEUE: null,
  WORKPERMIT_SET_UNDER_BATCH: null,
  WORKPERMIT_SET_QUICKSEARCH: null,
  // -------------------------------------------
  // --- project contractor
  PROJECT_CONTRACTOR_LOAD_CURRENT: null,
  SET_VENDOR_USERS: null,

  // ------------ table --------------------------------
  TABLE_SET_TABLE_INFO: null,
  TABLE_REMOVE_TABLE_INFO: null,
  TABLE_SET_PAGE_NUMBER: null,
  // ------------------dashboard-------------------------
  DB_LOAD_ALL: null,
  DB_MARK_LIST_STALE: null,
  DB_CLEAR_LIST_STALE: null,
  SET_SORT_ATTRIBUTES: null,
  // -------------------------------------------
  // --- standalone work permit
  TENANCY_CONTRACTOR_SET_ALL: null,
  TENANCY_CONTRACTOR_SET_INFO: null,
  TENANCY_CONTRACTOR_ADD: null,
  TENANCY_CONTRACTOR_CANCEL_EDIT: null,
  TENANCY_CONTRACTOR_START_EDIT: null,
  TENANCY_CONTRACTOR_DELETE: null,
  TENANCY_CONTRACTOR_VALIDATE: null,

  // -------------------------------------------
  // --- language
  CURRENT_LANGUAGE: null,

  // -------------------------------------------
  // --- buildings
  GET_ALL_BUILDINGS: null,
  ALL_BUILDINGS_OPTIONS: null,

  // -------------------------------------------
  // --- departments
  GET_ALL_DEPARTMENTS: null,

  // -------------------------------------------
  // --- categories
  ALL_CATEGORIES: null,
})

export default types
